import { Step, StepLabel, Stepper } from '@montugroup/design-system';
import { stepIconClasses } from '@mui/material/StepIcon';
import { stepLabelClasses } from '@mui/material/StepLabel';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export type PurchaseStage = 'Order' | 'Shipping' | 'Payment';

interface PurchaseStepperProps {
  stage: PurchaseStage;
}

const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  gap: theme.spacing(1),
  [`& .${stepIconClasses.root}.${stepIconClasses.active}`]: {
    color: theme.palette.secondary.main,
  },
  [`& .${stepIconClasses.root}.${stepIconClasses.completed}`]: {
    color: theme.palette.success.main,
  },
  [`& .${stepLabelClasses.label}.${stepLabelClasses.alternativeLabel}`]: {
    marginTop: 0,
  },
}));

export function PurchaseStepper(props: PurchaseStepperProps) {
  const StagesInOrder: PurchaseStage[] = ['Order', 'Shipping', 'Payment'];
  const { stage } = props;
  const index = StagesInOrder.indexOf(stage);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stepper activeStep={index} alternativeLabel={isMobile}>
      <Step key="Order" sx={{ paddingLeft: 0 }}>
        <StyledStepLabel>Order</StyledStepLabel>
      </Step>

      <Step key="Shipping">
        <StyledStepLabel>Shipping</StyledStepLabel>
      </Step>

      <Step key="Payment" sx={{ paddingRight: 0 }}>
        <StyledStepLabel>Payment</StyledStepLabel>
      </Step>
    </Stepper>
  );
}
